function getProductInventoryDelivery(config, availability) {
    var ref;
    const missingDeliveryDays = config.missingInventoryChannelStrategy.expectedDeliveryDays;
    if (typeof availability === 'undefined') {
        return missingDeliveryDays;
    }
    const availableChannels = availability.channels || {};
    const channels = Object.entries(availableChannels);
    var ref1;
    if ((ref1 = !channels.length) !== null && ref1 !== void 0 ? ref1 : !channels[0]) {
        return missingDeliveryDays;
    }
    const ONLINE_STORE = 'online-store';
    const [channelId, channel1] = channels.find((channel)=>channel[1].key === ONLINE_STORE
    ) || channels[0];
    const channelDeliveryConfig = (channel1 === null || channel1 === void 0 ? void 0 : channel1.key) && ((ref = config.inventoryChannels) === null || ref === void 0 ? void 0 : ref[channel1.key]) || config.inventoryChannels[channelId];
    if (!channelDeliveryConfig) {
        console.error(`Inventory channel ${channel1.key || channelId} is not configured.`);
        return missingDeliveryDays;
    }
    if (typeof channel1.availableQuantity === 'undefined') {
        return missingDeliveryDays;
    }
    const stockKey = channel1.availableQuantity > 0 ? 'onStock' : 'outOfStock';
    return channelDeliveryConfig.expectedDeliveryDays[stockKey];
}

export { getProductInventoryDelivery };
//# sourceMappingURL=get-product-inventory-delivery.js.map
